class LoyaltyProgress extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.setAttribute('aria-busy', true)

    this.getDetails = this.getDetails.bind(this)

    document.addEventListener('swell:setup', () => {
      this.getDetails()
    })
  }

  getDetails () {
    /* eslint-disable-next-line no-undef */
    const customerDetails = swellAPI.getCustomerDetails()

    let customerAmountSpend = 0
    let vipTierSpendNeeded = 0

    if (customerDetails.vipTierStats?.amountSpentCents) {
      customerAmountSpend = customerDetails.vipTierStats.amountSpentCents
      vipTierSpendNeeded = customerDetails.vipTierStatsNeeded.amountSpentCents
    }

    const progressPercentage = (customerAmountSpend / vipTierSpendNeeded) * 100
    const remainingProgress = 100 - progressPercentage
    const progress = Math.max(remainingProgress, 0)

    this.style.setProperty('--Progress', `-${progress}%`)

    const spendRemanining = vipTierSpendNeeded - customerAmountSpend
    const spendRemaningAsMoney = spendRemanining / 100

    if (this.externalEls?.spend?.element) {
      this.externalEls.spend.element.innerText = `£${spendRemaningAsMoney}`
    }

    const customerPointsBalance = customerDetails.pointsBalance

    if (this.externalEls?.points?.element) {
      this.externalEls.points.element.innerText = customerPointsBalance

      this.externalEls.points.element.setAttribute('aria-busy', false)
    }

    this.setAttribute('aria-busy', false)
  }
}

if (!customElements.get('loyalty-progress')) {
  customElements.define('loyalty-progress', LoyaltyProgress)
}
